import { CombinedError } from "@urql/core";

const networkErrorMessage = /request failed|failed to fetch|network\s?error/i;

// The backend answers with 401 without and 403 with an invalid or expired token
const authenticationStatusCodes = [401, 403];

/**
 * Decides which failed mutations the `offlineExchange` keeps in its queue to send again later. Besides being offline
 * (the default of graphcache), this covers a missing or expired token: after starting offline, the queue may be sent
 * before the session is renewed, and the changes must not get lost then.
 */
export function isOfflineError(
  error: CombinedError | undefined,
  result?: { error?: CombinedError },
): boolean {
  const e = error ?? result?.error;
  if (!e?.networkError) {
    return false;
  }
  const status = (e.response as Response | undefined)?.status;
  if (status !== undefined) {
    return authenticationStatusCodes.includes(status);
  }
  return (
    (typeof navigator !== "undefined" && navigator.onLine === false) ||
    networkErrorMessage.test(e.networkError.message)
  );
}
